import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var Sensor433State;
(function (Sensor433State) {
    Sensor433State[Sensor433State["OFFLINE"] = 0] = "OFFLINE";
    Sensor433State[Sensor433State["TRIGGERED"] = 1] = "TRIGGERED";
})(Sensor433State || (Sensor433State = {}));
export var RadioSensor433;
(function (RadioSensor433) {
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["REVERSED"] = 1] = "REVERSED";
        StatusFlags[StatusFlags["IS_TRIGGERED_FLAG"] = 2] = "IS_TRIGGERED_FLAG";
        StatusFlags[StatusFlags["IDO_STATE_LOW_BATTERY_BIT"] = 4] = "IDO_STATE_LOW_BATTERY_BIT";
        StatusFlags[StatusFlags["IDO_STATE_BREAK_IN_BIT"] = 8] = "IDO_STATE_BREAK_IN_BIT";
        StatusFlags[StatusFlags["IDO_STATE_LEARN_BIT"] = 16] = "IDO_STATE_LEARN_BIT";
        StatusFlags[StatusFlags["RESERVE_5"] = 32] = "RESERVE_5";
        StatusFlags[StatusFlags["RESERVE_6"] = 64] = "RESERVE_6";
        StatusFlags[StatusFlags["IS_GUARD_STATE"] = 128] = "IS_GUARD_STATE";
    })(StatusFlags = RadioSensor433.StatusFlags || (RadioSensor433.StatusFlags = {}));
    let Type;
    (function (Type) {
        Type[Type["MAGNET"] = 0] = "MAGNET";
        Type[Type["MOTION"] = 1] = "MOTION";
        Type[Type["SMOKE"] = 2] = "SMOKE";
        Type[Type["LEAK"] = 3] = "LEAK";
        Type[Type["GAS"] = 4] = "GAS";
        Type[Type["LIQUD"] = 5] = "LIQUD";
    })(Type = RadioSensor433.Type || (RadioSensor433.Type = {}));
    RadioSensor433.TypeOptions = [
        { text: 'Датчик открытия двери/окна', value: Type.MAGNET },
        { text: 'Датчик движения', value: Type.MOTION },
        { text: 'Датчик дыма', value: Type.SMOKE },
        { text: 'Датчик протечки', value: Type.LEAK },
        { text: 'Датчик утечки газа', value: Type.GAS },
        { text: 'Датчик уровня жидкости', value: Type.LIQUD },
    ];
    function getType(sensor) {
        return (sensor.type & 0x7f);
    }
    RadioSensor433.getType = getType;
    function setType(sensor, new_type) {
        return {
            ...sensor,
            type: (sensor.type & 128) | new_type,
        };
    }
    RadioSensor433.setType = setType;
    function isTriggered(state) {
        return (state.status & StatusFlags.IS_TRIGGERED_FLAG) > 0;
    }
    RadioSensor433.isTriggered = isTriggered;
    let Flags;
    (function (Flags) {
        Flags[Flags["EVENT_TO_SERVER_FLAG_INVERTED"] = 1] = "EVENT_TO_SERVER_FLAG_INVERTED";
        Flags[Flags["NO_GUARD_CTRL_ENABLE"] = 128] = "NO_GUARD_CTRL_ENABLE";
        Flags[Flags["IS_WORKER_TRIGGERED_FLAG"] = 256] = "IS_WORKER_TRIGGERED_FLAG";
    })(Flags = RadioSensor433.Flags || (RadioSensor433.Flags = {}));
    function isEventToServer(sensor) {
        return !isFlagSet(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED);
    }
    RadioSensor433.isEventToServer = isEventToServer;
    function isWorkingSensor(sensor) {
        return isFlagSet(sensor, Flags.IS_WORKER_TRIGGERED_FLAG);
    }
    RadioSensor433.isWorkingSensor = isWorkingSensor;
    function setEventToServer(sensor, eventToServer) {
        return setFlag(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED, !eventToServer);
    }
    RadioSensor433.setEventToServer = setEventToServer;
    function setWorkingSensor(sensor, checked) {
        return setFlag(sensor, Flags.IS_WORKER_TRIGGERED_FLAG, checked);
    }
    RadioSensor433.setWorkingSensor = setWorkingSensor;
    function isNoGuardControl(sensor) {
        return (sensor.setting_register & Flags.NO_GUARD_CTRL_ENABLE) != 0;
    }
    RadioSensor433.isNoGuardControl = isNoGuardControl;
    function setNoGuardControl(sensor, set) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~Flags.NO_GUARD_CTRL_ENABLE) |
                (set ? Flags.NO_GUARD_CTRL_ENABLE : 0),
        };
    }
    RadioSensor433.setNoGuardControl = setNoGuardControl;
    RadioSensor433.get = createAccessors(arrayGetSet('radiosensors433'), {
        name: 'Датчик движения',
        unique_id: 1234567,
        type: Type.MAGNET,
        rol_triggered: [],
        trigger_reset_time: 1.0,
        setting_register: 0,
    });
})(RadioSensor433 || (RadioSensor433 = {}));
